// DS1.12.2
import React from 'react';
import FavStarFill from '@wix/da-ds/pkg/Icons/24x24/FavStarFill';
import GallectionCoverDumbo from '../../GallectionCoverDumbo';
import s from './GallectionCover.scss';
const GallectionCover = ({ gallection })=>{
    return /*#__PURE__*/ React.createElement(GallectionCoverDumbo, {
        width: 70,
        height: 40,
        gallection: gallection,
        className: s['cover'],
        placeholderClassName: s['cover-placeholder'],
        placeholder: /*#__PURE__*/ React.createElement(FavStarFill, null)
    });
};
GallectionCover.displayName = 'GallectionCover';
export default GallectionCover;

//# sourceMappingURL=GallectionCover.js.map